import { ideaConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService } from "../_services";
import { alertActions } from ".";

export const ideasActions = {
  saveIdea,
  getIdeasList,
  deleteIdeas
};

//-- Login function
function saveIdea(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(ideaConstants.IDEA_ADDED_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      ideaData => {
        dispatch(commonAction.success(ideaConstants.IDEA_ADDED_SUCCESS, ideaData));
      },
      error => {
        dispatch(commonAction.failure(ideaConstants.IDEA_ADDED_FAILURE, error));
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

//-- getIdeasList
function getIdeasList(apiName, ideaData) {

  return dispatch => {

      dispatch(
          commonAction.request(ideaConstants.IDEA_LIST_REQUEST, ideaData)
      );
      commonService.withTokenPut(apiName, ideaData).then(
          notification => {

              dispatch(
                  commonAction.success(ideaConstants.IDEA_LIST_SUCCESS, notification)
              );
          },
          error => {
              dispatch(
                  commonAction.failure(ideaConstants.IDEA_LIST_ERROR, error)
              );
              dispatch(alertActions.error(error.response.data.error));
          }
      );
  };
}




//delete category
function deleteIdeas(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(ideaConstants.IDEA_DELETE_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      ideaData => {
        dispatch(commonAction.success(ideaConstants.IDEA_DELETE_SUCCESS, ideaData));
      },
      error => {
        dispatch(commonAction.failure(ideaConstants.IDEA_DELETE_FAILURE, error));
      }
    );
  };
}